export default __webpack_public_path__ + "static/media/red-clock.2f391a22.svg";